<template>
  <div :class="{'root-container': !isMenuMiniSize, 'root-container-thin-menu': isMenuMiniSize}">
    <portal-target name="modal-robo-list"></portal-target>
    <!-- 雇用ロボ一覧 -->
    <template v-if="!$route.query.view">
      <RoboEmploymentList :PCTRLLOG="CTRLLOG"/>
    </template>
    <!-- シナリオ編集 -->
    <template v-else-if="$route.query.view === 'scenario'">
      <ScenarioView ref="scenario" :isCreate="false" @return-goal-error-count="returnGoalErrorCount" @return-ope-flag="returnOpeFlag" @component-ready="componentReady" :PCTRLLOG="CTRLLOG"/>
    </template>
    <!-- ロボ出勤 -->
    <template v-else-if="$route.query.view === 'sitemap'">
      <Sitemap @changeScnList="movePartsEdit"/>
    </template>
  </div>
</template>

<script>
import { mapState }       from 'vuex'
import RoboEmploymentList from '@/components2/Robo/screen/RoboEmploymentList'
import ScenarioView       from '@/views/DashBoard/ChatBot/ScenarioView'
import Sitemap            from '@/views/DashBoard/ChatBot/Sitemap'
import controlLogMixin    from '@/mixins/controlLogMixin'

export default {
  name: 'RoboList',
  componentName: 'RoboList',
  components: {
    RoboEmploymentList,
    ScenarioView,
    Sitemap,
  },
  mixins: [
    controlLogMixin
  ],
  computed: {
    ...mapState('auth', ['user']),
    ...mapState("setting",["isMenuMiniSize"]),
  },
  data () {
    return {
      /**
       * コンポーネント名
       * @type  {String}
       */
      COMPONENT_NAME: 'RoboList',
      /**
       * 求人ページ表示ページ数
       * @type  {Number}
       */
      pages: 1,
      /**
       * 求人ページ判断フラグ
       * true：求人ページまたはカスタムページ、false：ホームページ
       * @type  {Boolean}
       */
      isRecruitPage: false,
      /**
       * GOAL設定エラー有無フラグ
       * @type  {Boolean}
       */
      isGoalError: false,
      /**
       * 子コンポーネントの操作有無フラグ
       * @type  {Boolean}
       */
      isOpeFlag: false,
      /**
       * 子コンポーネントの準備状態
       * @type  {Boolean}
       */
      isComponentReady: false
    }
  },
  /**
   * 親コンポーネント外または子コンポーネント内での画面遷移
   * @param  {Route} to 次のルート
   * @param  {Route} from 現在のルート
   * @param  {Function} next 次のフック
   */
  beforeRouteLeave(to, from, next) {
    if (this.isComponentReady) {
      let ret = this.pageTransition()
      next(ret)
    } else {
      next()
    }
  },
  created () {
    // ユーザーのロボブックマーク取得
    this.$store.dispatch('auth/getUserChatBotBookMark', null)
    // パーツセット取得
    this.$store.dispatch('chatbot/getRoboPartsSet', this.user.companyID)
    // 求人ページ一覧取得
    this.$store.dispatch('sitemap/getSitemapEmploymentListAll')
    // 出勤中ロボ一覧取得
    this.$store.dispatch('sitemap/getSitemapRoboList')
    // サイトマップ構築待ち一覧取得
    this.$store.dispatch('sitemap/getSitemapWaitList')
    // ホームページ一覧取得
    this.$store.dispatch('sitemap/getSitemapRecruitListAll')
    // カスタムページ一覧取得
    this.$store.dispatch('sitemap/getSitemapCustomListAll')

    // 求人ページ一覧またはカスタムページ一覧の表示ページ数設定
    if (this.$route.query.pages !== undefined) {
      if (this.$route.query.pages >= 1) {
        let pages = Number(this.$route.query.pages)
        const recruitPageData = {
          pages       : pages,
          per_page    : 30,
          content_type: 4
        }
        this.$store.dispatch('sitemap/getSitemapRecruitList', recruitPageData)
        const customPageData = {
          pages       : pages,
          per_page    : 30,
          content_type: 5
        }
        this.$store.dispatch('sitemap/getSitemapCustomList', customPageData)
      }
    } else {
      const recruitPageData = {
        pages       : 1,
        per_page    : 30,
        content_type: 4
      }
      this.$store.dispatch('sitemap/getSitemapRecruitList', recruitPageData)
      const customPageData = {
        pages       : 1,
        per_page    : 30,
        content_type: 5
      }
      this.$store.dispatch('sitemap/getSitemapCustomList', customPageData)
    }
  },
  mounted (){
    // 求人ページ内容取得
    this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
    // 表示シナリオ取得
    if (this.$route.query.scenario) {
        this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: this.$route.query.scenario })
    }
    if (this.$route.query.pages && !this.$route.query.view) {
      if (this.$route.query.pages >= 1) {
        this.pages = Number(this.$route.query.pages)
        this.$store.dispatch('employmentPage/getContentsList', {pages: this.pages, isRecruitPage: this.isRecruitPage})
      }
    }
  },
  methods: {
    /**
     * シナリオ編集画面に遷移
     * @param  {string} scenarioName シナリオID
     * @param  {Dictionary} robo ロボ
     */
    movePartsEdit (scenarioName, robo) {
      // 移動前のシナリオ名クリア
      this.$store.dispatch('chatbot/setScenarioTitleBeforeChange', '')
      // 移動先のシナリオ取得
      this.$store.dispatch('chatbot/getScenario', { companyid: this.user.companyID, scenarioName: scenarioName })
      // 移動先シナリオのロボ選択
      this.$store.dispatch('chatbot/selectChatbot', robo)
      // シナリオ移動
      this.$router.push('/client/chatbot?view=scenario&scenario=' + robo.scenario_name)
    },
    /**
     * シナリオ編集画面から遷移しようとしたときの処理
     */
    pageTransition () {
      // ページ遷移検出
      this.$refs.scenario.isOpeFlag()
      if (!this.isOpeFlag) {
        // 子コンポーネントでの画面遷移ではない
        this.$refs.scenario.checkGoalErrorCount()
        // GOAL設定エラーチェック
        if (this.isGoalError) {
          let ret = confirm('ゴールが一つも設定されていません。画面を移動してもよろしいですか？')
          return ret
        } else {
          return true
        }
      } else {
        // 子コンポーネントのフラグをクリアする
        this.$refs.scenario.clearOpeInfo()
        return true
      }
    },
    /**
     * GOAL設定エラー取得
     * @param  {boolean} isError GOAL設定エラー有無フラグ
     */
    returnGoalErrorCount (isError) {
      this.isGoalError = isError
      // 子コンポーネントのフラグをクリアする
      this.$refs.scenario.clearOpeInfo()
    },
    /**
     * 子コンポーネントの操作フラグ取得
     * @param  {boolean} isOpeFlag 子コンポーネントの操作有無フラグ
     */
    returnOpeFlag (isOpeFlag) {
      this.isOpeFlag = isOpeFlag
    },
    /**
     * 子コンポーネントの準備状態取得
     * @param  {boolean} isReady 子コンポーネントの準備状態
     */
    componentReady (isReady) {
      this.isComponentReady = isReady
    }
  },
}
</script>

<style lang="scss" scoped>
.root-container {
  height: 100vh;
  width: calc(100vw - 200px);
}
.root-container-thin-menu {
  height: 100vh;
  width: calc(100vw - 55px);
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/Robo/RoboList.vue